<template>
  <div :style="{ width: width }">
    <div class="image-container">
      <img
        loading="lazy"
        class="image-asspec-ratio"
        :aria-label="areaLabel"
        :src="url + imageName"
        :alt="imageName"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
    },
    imageName: {
      type: String,
    },
    width: {
      type: String,
    },
    areaLabel: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.image-container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding-top: calc(591.44 / 1127.34 * 100%);
}
.image-asspec-ratio {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
